import { getAuthCode, getRepayUrl } from '@/api/user/user'
import enums from '@/libs/enums'
import { getUrlQuery } from '@/libs/tools'
import { getCheckoutUrl } from '@/services/base'
import { appStore } from '@/stores'
const isCN = appStore.isCN
/**
 * 跳转到pricing页面
 * @param {*} pricingListType 0:个人版收银台，1：企业版，2：教育版 3：数字签名
 */
export const redirectToPricing = (pricingListType = 0) => {
  const channel = getUrlQuery('channel')
  const subPid = getUrlQuery('subPid')
  const query = []
  if (channel) query.push(`channel=${channel}`)
  if (subPid) query.push(`subPid=${subPid}`)
  const pricingUrl = [enums.websiteUrl.pricingIndividuals, enums.websiteUrl.pricingEnterprises, enums.websiteUrl.pricingEducation, enums.websiteUrl.pricingSign][pricingListType]
  if (window === window.parent) {
    // location.href = pricingUrl + '?' + query.join('&')
    window.open(pricingUrl + '?' + query.join('&'), '_blank')
  } else {
    window.open(pricingUrl, '_blank')
  }
}

/**
 * 跳转到收银台
 * @param {Object} urlQuery 进入收银台时自定义参数
 */
export const gotoCheckout = async (urlQuery, pricingListType = 0) => {
  if (isCN) {
    let checkoutUrl = getCheckoutUrl(urlQuery, pricingListType)
    if (window === window.parent) {
      const { data } = await getAuthCode()
      if (urlQuery) {
        checkoutUrl += `&${urlQuery}`
      }
      checkoutUrl += `&code=${data.code}&userSync=1`
      console.log(checkoutUrl)
      location.href = checkoutUrl
    } else {
      if (urlQuery) checkoutUrl += `&${urlQuery}`
      window.open(checkoutUrl, '_blank')
    }
  } else {
    redirectToPricing(pricingListType)
  }
}

/**
 * 跳转到重新支付页面
 * @param {String} orderNo 
 * @param {Number} orderRegion 0: 海外订单，1: 国内订单
 */
export const gotoRepayment = async (orderNo, orderRegion) => {
  try {
    const { data } = await getRepayUrl(orderNo)
    const authCodeRes = await getAuthCode()
    let newUrl = data + `?&code=${authCodeRes.data.code}&userSync=1`
    if (data.includes('?')) {
      newUrl = data + `&code=${authCodeRes.data.code}&userSync=1`
    }
    if (!appStore.isProd && orderRegion === 1) {
      newUrl += '&isCN=1'
    }
    window.open(newUrl, '_blank')
  } catch (error) {
    console.log(error)
  }
}
